<div class="d-flex flex-column full-width">
  <div
    class="option-row mb-2"
    *ngFor="let option of options; let i = index"
  >
    <div class="d-flex flex-row align-items-start full-width">
      <mat-form-field class="no-subscript option-label mr-2">
        <mat-label>Radio Label</mat-label>
        <input
          matInput
          [(ngModel)]="option.label"
          [disabled]="disabled"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="setConfiguration()"
        />
      </mat-form-field>
      <mat-form-field class="no-subscript condition-value mr-2">
        <mat-label>Condition Value</mat-label>
        <input
          matInput
          [value]="option.id"
          disabled
        />
      </mat-form-field>
      <cl-editor-status
        class="status-selector mr-2"
        [disabled]="disabled"
        [configuration]="getStatusConfiguration(option)"
        [checklistTemplate]="checklistTemplate"
        [statusLabel]="'Next Status'"
        (selected)="statusSelected(option, $event)"
      ></cl-editor-status>
      <button
        mat-icon-button
        color="warn"
        type="button"
        [disabled]="disabled || options.length <= 1"
        (click)="removeOption(option)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <role-selection
      class="full-width"
      [noSubscript]="(getSelectedRoles(option).length ?? 0) > 0"
      [roles]="getSelectedRoles(option)"
      [disabled]="disabled"
      hint="Notification won't be sent without first selecting a Role"
      label="Roles to Notify"
      (changed)="rolesSelected(option, $event)"
    ></role-selection>
  </div>
  <div>
    <button
      mat-stroked-button
      color="primary"
      type="button"
      [disabled]="disabled"
      (click)="addOption()"
    >
      <mat-icon>add</mat-icon>
      Add Option
    </button>
  </div>
</div>
